import request from './index'
// import QS from 'qs'
/**
 * 企业详情
 */
export function getSysEntInfo(query) {
  const entId = query.entId
  return request({
    url: `/zhongcheyun/portal/2_11_0/${entId}`,
    method: 'GET',
    params: query,
    headers: { scope: 1 },
  })
}
/**
 * 风格设置详情
 */
export function getThemeData(query) {
  
  const id = query.id
  return request({
    url: `/zhongcheyun/portal/style/2_11_0/${id}`,
    method: 'GET',
    params: query,
    headers: { scope: 1 },
  })
}

/**
 * 产品列表
 */
export function getProductList(query) {
  return request({
    url: `/zhongcheyun/portal/product/list/2_11_0/total`,
    method: 'GET',
    params: query,
    headers: { scope: 1 },
  })
}
/**
 * 产品详情
 */
export function getProductDetail(query) {
  const id = query.id
  return request({
    url: `/zhongcheyun/portal/product/2_11_0/${id}`,
    method: 'GET',
    params: query,
    headers: { scope: 1 },
  })
}
/**
 * 动态列表
 */
export function getNewsList(query) {
  return request({
    url: `/zhongcheyun/content/list/2_11_0/total`,
    method: 'GET',
    params: query,
    headers: { scope: 1 },
  })
}
/**
 * 动态详情
 */
export function getNewsDetail(query) {
  const id = query.id
  return request({
    url: `/zhongcheyun/content/${id}`,
    method: 'GET',
    params: query,
    headers: { scope: 1 },
  })
}



// WEBPACK FOOTER //
// ./src/api/theme.js